// Updating Initial State
export default {
  session: {
    active: false,
    code: 404,
    message: null,
    token: null
  },
  data: {},
  content: {},
  synthesis: {}
}



// WEBPACK FOOTER //
// ./src/reducers/initialState.js